import { jsx as _jsx } from "react/jsx-runtime";
export const ImageFit = props => {
    const { src, fit, position, supportFitPositionInIE = true, component, ...residualProps } = props;
    if (component || (supportFitPositionInIE && (fit || position))) {
        const Component = component || "div";
        return (_jsx(Component, { ...residualProps, style: {
                ...residualProps.style,
                backgroundImage: `url("${src}")`,
                backgroundSize: fit,
                backgroundPosition: position || "center",
                backgroundRepeat: "no-repeat"
            } }));
    }
    return (_jsx("img", { alt: "", src: src, ...residualProps, style: {
            ...residualProps.style,
            objectFit: fit,
            objectPosition: position
        } }));
};
//# sourceMappingURL=ImageFit.js.map